exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-icon[data-v-014adf67] {\n  background: #2196f3 !important;\n}\n", ""]);

// exports
